export default __webpack_public_path__ + "static/media/bannerLightImg.367e7969.png";